/*
 * SPDX-License-Identifier: Proprietary
 *
 * Copyright 2021 Jeremy A Gray <gray@flyquackswim.com>.
 */

import React from 'react';

import './Footer.css';

function Footer(props) {
  return (
    <div className="AppFooter">
      <p>
        Developed and hosted by <a href="https://www.flyquackswim.com/">FlyQuackSwim</a>.  Copyright &#169; 2021.
      </p>
    </div>
  );
}

export default Footer;
